import * as React from 'react';

import Revenova from '../assets/revenova-logo.png';

export default function RevenovaLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  return <img src={Revenova} alt='Revenova logo' {...props} />;
}
